import createSvgIcon from '@mui/material/utils/createSvgIcon';

const PendingReview = createSvgIcon(
  <svg
    viewBox="0 0 25 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <g
      clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 22.5C18.299 22.5 23 17.799 23 12C23 6.20101 18.299 1.5 12.5 1.5C6.70101 1.5 2 6.20101 2 12C2 17.799 6.70101 22.5 12.5 22.5ZM12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24ZM9.53703 12.8092C9.9549 12.4511 10.4444 12.1788 10.9719 12C10.4444 11.8212 9.9549 11.5489 9.53703 11.1908C8.73069 10.4996 8.25 9.53515 8.25 8.5V7H7.75C7.33579 7 7 6.66421 7 6.25C7 5.83579 7.33579 5.5 7.75 5.5H17.25C17.6642 5.5 18 5.83579 18 6.25C18 6.66421 17.6642 7 17.25 7H16.75V8.5C16.75 9.53515 16.2693 10.4996 15.463 11.1908C15.0451 11.5489 14.5556 11.8212 14.0281 12C14.5556 12.1788 15.0451 12.4511 15.463 12.8092C16.2693 13.5004 16.75 14.4649 16.75 15.5V17H17.25C17.6642 17 18 17.3358 18 17.75C18 18.1642 17.6642 18.5 17.25 18.5H7.75C7.33579 18.5 7 18.1642 7 17.75C7 17.3358 7.33579 17 7.75 17H8.25V15.5C8.25 14.4648 8.73069 13.5004 9.53703 12.8092ZM12.5 13.25C11.7365 13.25 11.0232 13.511 10.5132 13.9481C10.0068 14.3822 9.75 14.9439 9.75 15.5V16.75H15.25V15.5C15.25 14.9439 14.9932 14.3822 14.4868 13.9481C13.9768 13.511 13.2635 13.25 12.5 13.25ZM12.5 10.75C11.7365 10.75 11.0232 10.489 10.5132 10.0519C10.0068 9.61781 9.75 9.05615 9.75 8.5V7.25H15.25V8.5C15.25 9.05615 14.9932 9.61781 14.4868 10.0519C13.9768 10.489 13.2635 10.75 12.5 10.75Z"
      />
    </g>
    <defs>
      <clipPath
        id="clip0">
        <rect
          width="24"
          height="24"
          transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>,
  'PendingReview'
)

export default PendingReview
